import { CellContext, Row } from '@tanstack/react-table';

/*  Shared  */
import { BrowserBubbles } from 'application/Shared/Components/Avatars';
import { BROWSER_BASENAMES } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

interface Browser {
    application: {
        baseName: string;
    };
}

/**
 * Reusable filter column configuration for browsers
 */
export const browserFilter = {
    defaultOptions: [
        {
            options: [
                BROWSER_BASENAMES.CHROME,
                BROWSER_BASENAMES.CHROME_ALT,
                BROWSER_BASENAMES.EDGE,
                BROWSER_BASENAMES.EDGE_CHROMIUM,
                BROWSER_BASENAMES.FIREFOX,
                BROWSER_BASENAMES.BRAVE,
                BROWSER_BASENAMES.OPERA,
                BROWSER_BASENAMES.SAFARI,
                'not-data'
            ]
        }
    ]
};

/**
 * Filter function for browsers. Filters rows based on the selected browser(s).
 * If no browsers are selected, all rows are included.
 * @param {Row<any>} row - The row data
 * @param {string} columnId - The column ID
 * @param {string[]} filterValue - The filter value
 *
 * @returns {boolean} - Whether the row should be included in the filtered results
 */
export function filterBrowsers<TData>(
    row: Row<TData>,
    columnId: string,
    filterValue: string[]
): boolean {
    if (filterValue.length === 0) {
        return true;
    }

    if (!row.getValue(columnId) && filterValue.includes('not-data')) {
        return true;
    }

    return ((row.getValue(columnId) as Browser[]) || []).some(
        ({ application }) => filterValue.includes(application.baseName)
    );
}

/**
 * Cell component for rendering browser bubbles.
 * @param {Object} cell - The cell data
 *
 * @returns {React.ReactElement} - The rendered cell component
 */
export const BrowserBubblesCell = <TData,>({
    cell
}: CellContext<TData, unknown>): React.ReactElement => (
    // @ts-expect-error -- Remove once we have a proper type for the component
    <BrowserBubbles
        browsers={cell.getValue()}
        max={3}
        tooltipPlacement="left"
    />
);
